import { __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import { toast } from 'react-toastify';
export { ToastContainer } from 'react-toastify';
import React__default from 'react';
import Toaster from '../components/display/Toaster/index.js';

var showZigToast = function (type) { return function (message, options) {
    return toast(React__default.createElement(Toaster, { variant: type, caption: message, id: type && "toast__".concat(type) }), __assign({ type: type, icon: false }, options));
}; };
function useToast() {
    return {
        success: showZigToast("success"),
        error: showZigToast("error"),
        info: showZigToast("info"),
    };
}

export { showZigToast, useToast };
